/* eslint-disable */
import React, {Component} from 'react'
import {Input, Grid} from 'react-spreadsheet-grid'
import set from 'lodash.set'
import {Collapse} from 'react-collapse'
import {Button, Col, Row, Form, Modal, OverlayTrigger, Popover} from "react-bootstrap"
import Select, {components, DropdownIndicatorProps} from 'react-select'
import {AddFieldTable} from "./AddFieldTable"
import del from "../../assets/icons/del.png"
import arrow_up from "../../assets/icons/dark_arrow_up.png"
import arrow_down from "../../assets/icons/dark_arrow_down.png"
import {Typography} from "@material-ui/core"
import add from "../../assets/icons/add.png"
import {IMaskInput} from "react-imask"
import {Icon} from '@iconify/react'
import clockIcon from '@iconify/icons-svg-spinners/clock'
import clock from '../../assets/icons/clock.png'
import triangle from '../../assets/icons/triangle.png'
import cloneDeep from 'lodash/cloneDeep'
import red_clock from '../../assets/icons/red-clock.png'
import loadingIcon from '@iconify/icons-uiw/loading'
import search from '../../assets/icons/search.png'
import LazyLoad from 'react-lazy-load';

export class FieldTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            rows: [],
            loading: true,
            save: -1,
            modalShow: false,
            columnsRegion: [],
            columnsOneRegion: [],
            clockIsError: false,
            syncModalShow: false,
            cropwise_fields_all: [],
            modalSowId: '',
            synchronising: false,
            sync_loading: false,
            isCheckAll: true,
            sort_fields: {name: true, area: false},
            check_cropwise: false
        }
        this.saveData = this.saveData.bind(this)
        this.onFieldChange = this.onFieldChange.bind(this)
        this.delFieldModal = this.delFieldModal.bind(this)
        this.syncModal = this.syncModal.bind(this)
        this.checkAll = this.checkAll.bind(this)
        this.checkField = this.checkField.bind(this)
        this.synchronise = this.synchronise.bind(this)
        this.trackScrolling = this.trackScrolling.bind(this)
        this.sort_field_list = this.sort_field_list.bind(this)
        this.onSyncClick = this.onSyncClick.bind(this)
        this.filterFieldList = this.filterFieldList.bind(this)
    }

    componentDidMount() {
        this.populateFieldsData()
    }

    trackScrolling = () => {
        const wrappedElement = document.getElementById('sync-table-container');
        if (wrappedElement.scrollHeight - wrappedElement.scrollTop === wrappedElement.clientHeight) {
            document.getElementById('sync-table-container').classList.add('no-after')
        } else {
            document.getElementById('sync-table-container').classList.remove('no-after')
        }
    }

    expandRow = (rowId) => {
        const row = this.state.rows.find((row) => {
            return row.id === rowId;
        });
        row.expand = !row.expand
        this.setState({expand: row.expand ? "Скрыть" : "Раскрыть"})
    }

    addRowRegion = (rowId) => {
        fetch('api/region?fieldId=' + rowId, {
            method: 'POST',
            headers: !this.props.token ? {} : {'Authorization': `Bearer ${this.props.token}`},
        }).then((response) => {
            if (response.ok) {
                response.json().then((result) => {
                    let row = this.state.rows.find((row) => {
                        return row.id === rowId;
                    });
                    row.regions = row.regions.concat(result)
                    this.setState({rows: this.state.rows})
                })
            }
        });
    }

    removeField = (rowId) => {
        fetch('api/Field?id=' + rowId, {
            method: 'DELETE',
            headers: !this.props.token ? {} : {'Authorization': `Bearer ${this.props.token}`}
        }).then((response) => {
            if (response.ok) {
                this.setState({rows: this.state.rows.filter((row) => row.id !== rowId)})
            }
        });
    }

    onFieldChange = (rowId, field, value1) => {
        let value = value1
        if (field === 'area')
            value = value1.replace(/\s/g, "")
        const modifiedRows = [].concat(this.state.rows);
        const row = modifiedRows.find((row) => {
            return row.id === rowId;
        });
        set(row, field, value);
        this.forceUpdate()
    }

    removeRowRegion = (rowId) => {
        fetch('api/region?id=' + rowId, {
            method: 'DELETE',
            headers: !this.props.token ? {} : {'Authorization': `Bearer ${this.props.token}`}
        }).then((response) => {
            if (response.ok) {
                response.json().then((result) => {
                    let row = this.state.rows.find((row) => {
                        return row.id === result;
                    });
                    row.regions = row.regions.filter(e => e.id !== rowId)
                    this.setState({rows: this.state.rows});
                })
            }
        });
    }

    saveData() {
        this.setState({save: 0})
        fetch('api/field', {
            method: 'PUT',
            headers: !this.props.token ? {} : {
                'Authorization': `Bearer ${this.props.token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.state.rows)
        })
            .then((response) => {
                if (response.ok) {
                    this.setState({save: 2})
                    setTimeout(() => this.setState({save: -1}), 3000)
                } else {
                    this.setState({save: 1})
                    setTimeout(() => this.setState({save: -1}), 3000)
                }
            });
    }

    delFieldModal(fieldName, rowId) {
        return (
            <Modal show={this.state.modalShow}
                   backdrop="static"
                   keyboard={false}
                   size='lg'
                   id='field-del-modal'
                   onHide={() => this.setState({modalShow: false})}
                   centered>
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <Modal.Title>Вы действительно хотите удалить поле "{fieldName}"?</Modal.Title>
                    <div className="btn-row">
                        <Button onClick={() => this.setState({modalShow: false})}>
                            Нет
                        </Button>
                        <Button onClick={() => {
                            this.removeField(rowId)
                            this.setState({modalShow: false})
                        }}> Да </Button>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }

    checkAll() {
        this.state.cropwise_fields_all.map((item) => {
            item.checked = !this.state.isCheckAll
        })
        this.setState({isCheckAll: !this.state.isCheckAll})
    }

    checkField(row) {
        this.state.cropwise_fields_all.find((r) => r.id === row.id).checked = !row.checked
        let check = new Set()
        this.state.cropwise_fields_all.map((r) => {
            check.add(r.checked)
        })
        if (check.size === 1 && check.has(true)) {
            this.setState({isCheckAll: true})
        } else {
            this.setState({isCheckAll: false})
        }
    }

    synchronise() {
        this.setState({synchronising: true})
        let checked_fields = cloneDeep(this.state.cropwise_fields_all.filter((row) => row.checked))
        checked_fields.map((row) => delete row.checked)
        fetch('api/field/createFromCropwise', {
            method: 'POST',
            headers: !this.props.token ? {} : {
                'Authorization': `Bearer ${this.props.token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(checked_fields)
        }).then(async (response) => {
            if (response.ok) {
                const body = await response.json()
                this.setState({synchronising: false, syncModalShow: false, rows: body})
            } else {
                this.setState({synchronising: false, clockIsError: true})
                document.getElementById('sync-error').innerHTML = 'Ошибка синхронизации!'
            }
        })
    }

    async onSyncClick() {
        this.setState({sync_loading: true})
        const cropwise_fields_response = await fetch('api/field/getFromCropwise', {
            headers: !this.props.token ? {} : {'Authorization': `Bearer ${this.props.token}`}
        });
        const cropwise_fields_all = await cropwise_fields_response.json()
        const cropwise_fields = cropwise_fields_all.map((field) => ({
            id: field.id,
            name: field.name,
            area: field.area.toFixed(2),
            checked: true,
            hide: false,
        }))
        this.setState({cropwise_fields_all: cropwise_fields, sync_loading: false})
    }

    filterFieldList(value) {
        let rows = this.state.cropwise_fields_all
        rows.forEach((row) => {
            row.hide = !row.name.toLowerCase().includes(value.toLowerCase())
        })
        this.setState({cropwise_fields_all: rows})
    }

    filterFields(value) {
        let rows = this.state.rows
        rows.forEach((row) => {
            row.hide = !row.name.toLowerCase().includes(value.toLowerCase())
        })
        this.setState({rows: rows})
    }

    syncModal() {
        return (
            <Modal show={this.state.syncModalShow}
                   keyboard={false}
                   size='lg'
                   id='sync-modal'
                   onHide={() => this.setState({syncModalShow: false, clockIsError: false}, () => this.forceUpdate())}
                   centered>
                <Modal.Header closeButton>
                    <Modal.Title>Выберите поля</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.state.sync_loading ?
                        <div className='icon-container'><Icon icon={loadingIcon} className='loader' color="#abb3d1"
                                                              width="80" height="80"/></div> :
                        <>
                            <div className='search-container'>
                                <input onInput={(e) => this.filterFieldList(e.target.value)}
                                       className='search-input'/>
                                <img className='search-img' src={search} alt='search'/>
                            </div>
                            <div className="row name-btn-row">
                                <button onClick={() => this.sort_field_list('name')}
                                        className="col-names-btn col">Наименование
                                    <img id='sort-triangle-name' src={triangle} alt='sort'/>
                                </button>
                                <button onClick={() => this.sort_field_list('area')}
                                        className="col-names-btn col">Площадь, га
                                    <img id='sort-triangle-area' src={triangle} alt='sort'/>
                                </button>
                            </div>
                            <div className="row">
                                <label className="checkbox-sync-all">
                                    <input name="stockCheck"
                                           key={this.state.isCheckAll}
                                           defaultChecked={this.state.isCheckAll}
                                           onChange={this.checkAll}
                                           type="checkbox"/><span>l</span>
                                    <div className='check-all'>Выбрать все</div>
                                </label>
                            </div>
                            <div className="field-container">
                                <div className="table-container" id='sync-table-container'
                                     onScroll={this.trackScrolling}>
                                    {
                                        this.state.cropwise_fields_all.map((row) => {
                                            return (row.hide ? <></> :
                                                <label className={"checkbox-sync"}>
                                                    <input name="syncCheck"
                                                           key={row.checked}
                                                           defaultChecked={row.checked}
                                                           onChange={() => this.checkField(row)}
                                                           type="checkbox"/><span> l</span>
                                                    <div className='field-name-col'>{row.name}</div>
                                                    <div className='field-area-col'>{row.area}</div>
                                                </label>)
                                        })
                                    }
                                </div>
                            </div>
                            <div className="sync-btn-container">
                                <button className='sync-btn' id='sync-clock-btn' onClick={this.synchronise}
                                        disabled={this.state.synchronising}>
                                    {
                                        this.state.synchronising ?
                                            <Icon icon={clockIcon} color="#7fb94c" width="30" height="30"/> :
                                            this.state.clockIsError ? <img src={red_clock} alt='clock'/> :
                                                <img src={clock} alt='clock'/>
                                    }
                                    Синхронизировать
                                </button>
                                <span id='sync-error' className='error-span'></span>
                            </div>
                        </>}
                </Modal.Body>
            </Modal>
        )
    }

    sort_field_list(col) {
        const sort_field = this.state.sort_fields[col]

        function compare(a, b) {
            if (a[col] < b[col]) {
                return (sort_field ? -1 : 1);
            }
            if (a[col] > b[col]) {
                return (sort_field ? 1 : -1);
            }
            return 0;
        }

        this.setState({cropwise_fields_all: this.state.cropwise_fields_all.sort(compare)})
        this.state.sort_fields[col] = !this.state.sort_fields[col]
        this.state.sort_fields[col] ? document.getElementById('sort-triangle-' + col).classList.add('sort-rotate') :
            document.getElementById('sort-triangle-' + col).classList.remove('sort-rotate')
    }

    static renderTable(rows, addRow, columnsRegion, columnsOneRegion, expand, onFieldChange, delFieldModal, showModal, modalShowId) {
        const tableField = rows ? rows.map((row) => (
                <LazyLoad height={row.hide? '0': row.expand? 'fit-content':'80px'}>
                    {!row.hide ?
                        <div>
                            <div className="field-btn-container">
                                <button className="btn delete-field-btn"
                                        onClick={() => showModal(row.id)}><img src={del} alt='del'/></button>
                                <div className='field-btn'>
                                    {modalShowId === row.id ? delFieldModal(row.name, row.id) : <></>}
                                    <Row>
                                        <Col>
                                            Наименование поля:
                                        </Col>
                                        <Col>
                                            <Form.Control className='field-form' value={row.name}
                                                          style={{width: `${row.name.length}ch`}}
                                                          onChange={(event) => onFieldChange(row.id, 'name', event.target.value)}></Form.Control>
                                        </Col>
                                        <Col>/ Площадь: </Col>
                                        <Col><Form.Control className='field-form' value={row.area}
                                                           style={{
                                                               width: `${row.area.toString().length}ch`,
                                                               maxWidth: '100px'
                                                           }}
                                                           onChange={(event) => onFieldChange(row.id, 'area', event.target.value)}></Form.Control></Col>
                                        <Col> га</Col>
                                    </Row>
                                    <Button className='field-btn-arrow' onClick={() => expand(row.id)}>
                                        <img src={row.expand ? arrow_up : arrow_down} className='btn-arrow'
                                             alt='arrow'/>
                                    </Button>
                                </div>
                            </div>
                            <Collapse isOpened={row.expand}>
                                <div id="regions-table">
                                    <Grid
                                        columns={row.regions.length <= 1 ? columnsOneRegion : columnsRegion}
                                        rows={row.regions}
                                        isScrollable={false}
                                        focusOnSingleClick={true}
                                        getRowKey={row => row.id}
                                        rowHeight={90}
                                        disabledCellChecker={(row, columnId) => {
                                            return columnId === 'soilId' ||
                                                columnId === 'unit_measurements' ||
                                                columnId === 'button_remove' ||
                                                columnId === 'dateAnalyse'
                                        }}
                                    />
                                    <div className="add-btn-container">
                                        <button className="btn add-btn" onClick={() => addRow(row.id)}><img src={add}
                                                                                                            alt='add'/>
                                        </button>
                                    </div>
                                </div>
                            </Collapse>
                        </div> : <></>}
                </LazyLoad>
            )
        ) : []

        return tableField
    }

    render() {
        const showModal = (rowId) => {
            this.setState({modalShow: true, modalShowId: rowId})
        }
        let save = ''
        switch (this.state.save) {
            case 0:
                save = 'Идет сохранение...'
                break
            case 1:
                save = 'Ошибка'
                break
            case 2:
                save = 'Данные успешно сохранены'
                break
            default:
                save = ''
                break
        }
        let contents = this.state.loading
            ? <p><em>Загрузка...</em></p>
            : FieldTable.renderTable(
                this.state.rows,
                this.addRowRegion,
                this.state.columnsRegion,
                this.state.columnsOneRegion,
                this.expandRow,
                this.onFieldChange,
                this.delFieldModal,
                showModal,
                this.state.modalShowId)
        return (
            <div key=''>
                {this.state.syncModalShow ? this.syncModal() : <></>}
                <Row>
                    <Col className='field-page-label'>Поля</Col>
                    {this.state.check_cropwise ?
                        <button className='col sync-label'
                                onClick={() => {
                                    this.setState({syncModalShow: true}, () => this.onSyncClick())
                                }}>
                            Синхронизировать с Cropwise Operation
                        </button> : <></>}
                </Row>
                <AddFieldTable token={this.props.token} key={this.props.token}
                               addField={(value) => this.setState({rows: this.state.rows.concat(value)})}/>
                <div className='field-search-container'>
                    <input onInput={(e) => this.filterFields(e.target.value)}
                           className='search-input'/>
                    <img className='search-img' src={search} alt='search'/>
                </div>
                {contents}
                <OverlayTrigger
                    trigger="click"
                    show={save !== ''}
                    placement="right"
                    overlay={<Popover>{save}</Popover>}
                >
                    <Button onClick={() => this.saveData()}
                            className='save-field-btn'>Сохранить</Button>
                </OverlayTrigger>
            </div>
        );
    }

    async populateFieldsData() {
        const numberFormat = new Intl.NumberFormat('ru-RU')
        const numberElementFormat = new Intl.NumberFormat('ru-RU', {maximumFractionDigits: 0})

        function formatCell(value, element = false) {
            return value ? ((element ? numberElementFormat : numberFormat).format(value.toString().replace(',', '.')).replace(',', '.')) : 0
        }

        let check_cropwise = false
        fetch('api/field/checkCropwise', {
            headers: !this.props.token ? {} : {'Authorization': `Bearer ${this.props.token}`}
        }).then((response) => {
            if (response.ok) {
                check_cropwise = true
            }
        });

        const response = await fetch('api/field', {
            headers: !this.props.token ? {} : {'Authorization': `Bearer ${this.props.token}`}
        });
        const response_soils = await fetch('api/soil', {
            headers: !this.props.token ? {} : {'Authorization': `Bearer ${this.props.token}`}
        });
        let soils_list = [];
        const soils = await response_soils.json();
        soils.map((item) => (
            soils_list.push({value: item.id, label: item.name})
        ))
        soils_list = soils_list.sort((function (a, b) {
            if (a.label < b.label) {
                return -1;
            }
            if (a.label > b.label) {
                return 1;
            }
            return 0;
        }))

        let rows = await response.json()
        rows.map((row) => {
            Object.assign(row, {hide: false})
        })

        function compare(a, b) {
            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }
            return 0;
        }

        rows = rows.sort(compare)

        const onDateChange = (rowId, fieldId, value) => {
            const modifiedRows = [].concat(this.state.rows);
            const row = modifiedRows.find((row) => {
                return row.id === fieldId;
            });
            const rowRegion = row.regions.find((row) => {
                return row.id === rowId;
            });
            set(rowRegion, 'dateAnalyse', value);
        }
        const onRegionChange = (rowId, field, fieldId) => (value1) => {
            let value = value1
            if (field !== 'dateAnalyse' && field !== 'name')
                value = value1.replace(/\s/g, "").replace(',', '.')
            const modifiedRows = [].concat(this.state.rows);
            const row = modifiedRows.find((row) => {
                return row.id === fieldId;
            });
            const rowRegion = row.regions.find((row) => {
                return row.id === rowId;
            });
            set(rowRegion, field, value);
            if (/^element/.test(field))
                set(rowRegion, field.replace('element', 'elementMg'), 0)
            if (field === 'density' || field === 'depthSoil')
                for (let el in rowRegion.element) {
                    if (Number(rowRegion.elementMg[el]) !== 0) {
                        set(rowRegion, 'element.' + el, rowRegion.elementMg[el] * rowRegion.density * rowRegion.depthSoil / 10)
                    }
                }
        }
        const onRegion2Change = (rowId, field, fieldId) => (value1) => {
            let value = value1.replace(/\s/g, "")
            const modifiedRows = [].concat(this.state.rows);
            const row = modifiedRows.find((row) => {
                return row.id === fieldId;
            });
            const rowRegion = row.regions.find((row) => {
                return row.id === rowId;
            });
            set(rowRegion, 'element.' + field, value * rowRegion.density * rowRegion.depthSoil / 10);
            set(rowRegion, 'elementMg.' + field, value);
        }
        const onSelectChange = (rowId, field, fieldId) => (value) => {
            const modifiedRows = [].concat(this.state.rows);
            const row = modifiedRows.find((row) => {
                return row.id === fieldId;
            });
            const rowRegion = row.regions.find((row) => {
                return row.id === rowId;
            });
            rowRegion.soil = soils.find((s) => {
                return s.id === value.value;
            })
            set(rowRegion, field, value.value);
        }
        const del_button = (id) => {
            return (<button className="btn delete-row-btn"
                            onClick={() => this.removeRowRegion(id)}><img src={del} alt='del'/></button>)
        }
        const DropdownIndicator = (props: DropdownIndicatorProps<ColourOption, true>) => {
            return (
                <components.DropdownIndicator {...props}>
                    <img src={props.selectProps.menuIsOpen ? arrow_up : arrow_down} alt='arrow-down'
                         className='arrow'></img>
                </components.DropdownIndicator>
            );
        };

        function NoOptionsMessage(props) {
            if (props.options.length) return null;
            return <Typography className='no-options-label' {...props.innerProps}>Нет данных</Typography>;
        }

        const columnsOneRegion = [
            {
                title: 'Дата анализа',
                value: (row, {focus}) => {
                    return (
                        <IMaskInput
                            className='date-input'
                            mask={Date}
                            value={row.dateAnalyse}
                            min={new Date(2000, 0, 1)}
                            max={new Date(2050, 0, 1)}
                            onAccept={(value, mask) => onDateChange(row.id, row.fieldId, value)}
                            placeholder="00.00.0000"
                        />
                    );
                },
                id: 'dateAnalyse',
                width: 8,
                getCellClassName: () => "SpreadsheetGrid__cell_focused"
            }, {
                title: 'Площадь\nполя, га',
                value: (row, {focus}) => {
                    return (
                        <div className={row.area == '0' ? 'no-data-cell' : 'data-cell'}>
                            <Input
                                value={formatCell(row.area)}
                                focus={focus}
                                selectTextOnFocus={true}
                                onChange={onRegionChange(row.id, 'area', row.fieldId)}
                            />
                        </div>
                    );
                },
                id: 'area',
                width: 7,
            }, {
                title: 'Тип почвы',
                value: (row, {focus}) => {
                    return (
                        <Select
                            id="soil-select"
                            options={soils_list}
                            defaultValue={soils_list[soils_list.findIndex((r) => r.value === row.soilId)]}
                            onChange={onSelectChange(row.id, 'soilId', row.fieldId)}
                            className='in-table-select'
                            maxMenuHeight='244px'
                            components={{DropdownIndicator, NoOptionsMessage}}
                            theme={(theme) => ({
                                ...theme,
                                border: '1px solid #ABB3D1',
                                borderRadius: '10px',
                                colors: {
                                    ...theme.colors,
                                    primary: '#ABB3D1',
                                },
                            })}
                            styles={{
                                container: (baseStyles, state) => ({
                                    ...baseStyles,
                                    width: '90%',
                                    height: '70px',
                                }),
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    background: state.isFocused ? '#fff' : '#E9EAEE',
                                    height: '70px',
                                    width: '100%',
                                }),
                                menu: (baseStyles, state) => ({
                                    ...baseStyles,
                                    border: ' 1px solid #ABB3D1',
                                    borderRadius: '10px',
                                    margin: '0',
                                    fontSize: '18px !important',
                                }),
                                option: (baseStyles, state) => ({
                                    ...baseStyles,
                                    backgroundColor: state.isFocused ? 'rgba(226, 228, 239, 0.5)' : "white",
                                    height: '80px',
                                    lineHeight: '20px',
                                    fontSize: '18px !important',
                                }),
                                singleValue: (baseSyles) => ({
                                    ...baseSyles,
                                    whiteSpace: 'normal',
                                    height: '57px',
                                    textAlign: 'left',
                                    fontSize: '18px',
                                    lineHeight: '20px',
                                    color: '#201E44',
                                    margin: '0 !important'
                                }),
                            }}
                        />
                    );
                },
                id: 'soilId',
                width: 26,
                getCellClassName: () => "SpreadsheetGrid__cell_focused"
            }, {
                title: 'Гумус\n%',
                value: (row, {focus}) => {
                    return (
                        <div className={row.humus == '0' ? 'no-data-cell' : 'data-cell'}>
                            <Input
                                value={formatCell(row.humus)}
                                focus={focus}
                                selectTextOnFocus={true}
                                onChange={onRegionChange(row.id, 'humus', row.fieldId)}
                            />
                        </div>
                    );
                },
                id: 'humus',
                width: 5,
            }, {
                title: 'pH',
                value: (row, {focus}) => {
                    return (
                        <div className={row.pH == '0' ? 'no-data-cell' : 'data-cell'}>
                            <Input
                                value={formatCell(row.pH)}
                                focus={focus}
                                selectTextOnFocus={true}
                                onChange={onRegionChange(row.id, 'pH', row.fieldId)}
                            />
                        </div>
                    );
                },
                id: 'pH',
                width: 5,
            }, {
                title: 'Плотность\nг/см³',
                value: (row, {focus}) => {
                    return (
                        <div className={row.density == '0' ? 'no-data-cell' : 'data-cell'}>
                            <Input
                                value={formatCell(row.density)}
                                focus={focus}
                                selectTextOnFocus={true}
                                onChange={onRegionChange(row.id, 'density', row.fieldId)}
                            />
                        </div>
                    );
                },
                id: 'density',
                width: 7,
            }, {
                title: 'Глубина пахотного слоя, см',
                value: (row, {focus}) => {
                    return (
                        <div className={row.depthSoil == '0' ? 'no-data-cell' : 'data-cell'}>
                            <Input
                                value={formatCell(row.depthSoil)}
                                focus={focus}
                                selectTextOnFocus={true}
                                onChange={onRegionChange(row.id, 'depthSoil', row.fieldId)}
                            />
                        </div>
                    );
                },
                id: 'depthSoil',
                width: 7,
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <Col>
                            <Row>
                                <Input
                                    value='кг/га'
                                    focus={focus}
                                />
                            </Row>
                            <hr/>
                            <Row>
                                <Input
                                    value='мг/кг'
                                    focus={focus}
                                />
                            </Row>
                        </Col>
                    );
                },
                id: 'unit_measurements',
                width: 5,
            }, {
                title: 'N',
                value: (row, {focus}) => {
                    return (
                        <Col>
                            <Row className={row.element.n == '0' ? 'no-data-cell' : 'data-cell'}>
                                <Input
                                    value={formatCell(row.element.n, true)}
                                    focus={focus}
                                    selectTextOnFocus={true}
                                    onChange={onRegionChange(row.id, 'element.n', row.fieldId)}
                                />
                            </Row>
                            <hr/>
                            <Row className={row.elementMg.n == '0' ? 'no-data-cell' : 'data-cell'}>
                                <Input
                                    value={formatCell(row.elementMg.n, true)}
                                    focus={focus}
                                    selectTextOnFocus={true}
                                    onChange={onRegion2Change(row.id, 'n', row.fieldId)}
                                />
                            </Row>
                        </Col>
                    );
                },
                id: 'N',
                width: 5
            }, {
                title: 'P₂O₅',
                value: (row, {focus}) => {
                    return (
                        <Col>
                            <Row className={row.element.p2O5 == '0' ? 'no-data-cell' : 'data-cell'}>
                                <Input
                                    value={formatCell(row.element.p2O5, true)}
                                    focus={focus}
                                    selectTextOnFocus={true}
                                    onChange={onRegionChange(row.id, 'element.p2O5', row.fieldId)}
                                />
                            </Row>
                            <hr/>
                            <Row className={row.elementMg.p2O5 == '0' ? 'no-data-cell' : 'data-cell'}>
                                <Input
                                    value={formatCell(row.elementMg.p2O5, true)}
                                    focus={focus}
                                    selectTextOnFocus={true}
                                    onChange={onRegion2Change(row.id, 'p2O5', row.fieldId)}
                                />
                            </Row>
                        </Col>
                    );
                },
                id: 'P2O5',
                width: 5
            }, {
                title: 'K₂O',
                value: (row, {focus}) => {
                    return (
                        <Col>
                            <Row className={row.element.k2O == '0' ? 'no-data-cell' : 'data-cell'}>
                                <Input
                                    value={formatCell(row.element.k2O, true)}
                                    focus={focus}
                                    selectTextOnFocus={true}
                                    onChange={onRegionChange(row.id, 'element.k2O', row.fieldId)}
                                />
                            </Row>
                            <hr/>
                            <Row className={row.elementMg.k2O == '0' ? 'no-data-cell' : 'data-cell'}>
                                <Input
                                    value={formatCell(row.elementMg.k2O, true)}
                                    focus={focus}
                                    selectTextOnFocus={true}
                                    onChange={onRegion2Change(row.id, 'k2O', row.fieldId)}
                                />
                            </Row>
                        </Col>
                    );
                },
                id: 'K2O',
                width: 5
            }, {
                title: 'S',
                value: (row, {focus}) => {
                    return (
                        <Col>
                            <Row className={row.element.s == '0' ? 'no-data-cell' : 'data-cell'}>
                                <Input
                                    value={formatCell(row.element.s, true)}
                                    focus={focus}
                                    selectTextOnFocus={true}
                                    onChange={onRegionChange(row.id, 'element.s', row.fieldId)}
                                />
                            </Row>
                            <hr/>
                            <Row className={row.elementMg.s == '0' ? 'no-data-cell' : 'data-cell'}>
                                <Input
                                    value={formatCell(row.elementMg.s, true)}
                                    focus={focus}
                                    selectTextOnFocus={true}
                                    onChange={onRegion2Change(row.id, 's', row.fieldId)}
                                />
                            </Row>
                        </Col>
                    )
                        ;
                },
                id: 'S',
                width: 5
            }, {
                title: 'CaO',
                value: (row, {focus}) => {
                    return (
                        <Col>
                            <Row className={row.element.caO == '0' ? 'no-data-cell' : 'data-cell'}>
                                <Input
                                    value={formatCell(row.element.caO, true)}
                                    focus={focus}
                                    selectTextOnFocus={true}
                                    onChange={onRegionChange(row.id, 'element.caO', row.fieldId)}
                                />
                            </Row>
                            <hr/>
                            <Row className={row.elementMg.caO == '0' ? 'no-data-cell' : 'data-cell'}>
                                <Input
                                    value={formatCell(row.elementMg.caO, true)}
                                    focus={focus}
                                    selectTextOnFocus={true}
                                    onChange={onRegion2Change(row.id, 'caO', row.fieldId)}
                                />
                            </Row>
                        </Col>
                    )
                },
                id: 'caO',
                width: 5
            }, {
                title: 'Mg',
                value: (row, {focus}) => {
                    return (
                        <Col>
                            <Row className={row.element.mg == '0' ? 'no-data-cell' : 'data-cell'}>
                                <Input
                                    value={formatCell(row.element.mg, true)}
                                    focus={focus}
                                    selectTextOnFocus={true}
                                    onChange={onRegionChange(row.id, 'element.mg', row.fieldId)}
                                />
                            </Row>
                            <hr/>
                            <Row className={row.elementMg.mg == '0' ? 'no-data-cell' : 'data-cell'}>
                                <Input
                                    value={formatCell(row.elementMg.mg, true)}
                                    focus={focus}
                                    selectTextOnFocus={true}
                                    onChange={onRegion2Change(row.id, 'mg', row.fieldId)}
                                />
                            </Row>
                        </Col>
                    )
                },
                id: 'mg',
                width: 5
            },
            {
                title: '',
                value: (row) => {
                    return del_button(row.id);
                },
                id: 'button_remove',
                width: 0,
                getCellClassName: () => "SpreadsheetGrid__cell_focused"
            }
        ];
        const columnsRegion = [
            {
                title: 'Дата анализа',
                value: (row, {focus}) => {
                    return (
                        <IMaskInput
                            className='date-input'
                            mask={Date}
                            value={row.dateAnalyse}
                            min={new Date(2000, 0, 1)}
                            max={new Date(2050, 0, 1)}
                            onAccept={(value, mask) => onDateChange(row.id, row.fieldId, value)}
                            placeholder="00.00.0000"
                        />
                    )
                },
                id: 'dateAnalyse',
                width: 7,
                getCellClassName: () => "SpreadsheetGrid__cell_focused"
            }, {
                title: 'Наим.\nэл. уч.',
                value: (row, {focus}) => {
                    return (
                        <Input
                            placeholder='0'
                            value={row.name}
                            focus={focus}
                            selectTextOnFocus={true}
                            onChange={onRegionChange(row.id, 'name', row.fieldId)}
                        />
                    );
                },
                id: 'name',
                width: 6,
            }, {
                title: 'Площадь\nэл. уч., га',
                value: (row, {focus}) => {
                    return (
                        <div className={row.area == '0' ? 'no-data-cell' : 'data-cell'}>
                            <Input
                                value={formatCell(row.area)}
                                focus={focus}
                                selectTextOnFocus={true}
                                onChange={onRegionChange(row.id, 'area', row.fieldId)}
                            />
                        </div>
                    );
                },
                id: 'area',
                width: 7,
            }, {
                title: 'Тип почвы',
                value: (row, {focus}) => {
                    return (
                        <Select
                            id="soil-select"
                            options={soils_list}
                            defaultValue={soils_list[soils_list.findIndex((r) => r.value === row.soilId)]}
                            onChange={onSelectChange(row.id, 'soilId', row.fieldId)}
                            className='in-table-select'
                            maxMenuHeight='244px'
                            components={{DropdownIndicator, NoOptionsMessage}}
                            theme={(theme) => ({
                                ...theme,
                                border: '1px solid #ABB3D1',
                                borderRadius: '10px',
                                colors: {
                                    ...theme.colors,
                                    primary: '#ABB3D1',
                                },
                            })}
                            styles={{
                                container: (baseStyles, state) => ({
                                    ...baseStyles,
                                    width: '90%',
                                    height: '70px',
                                }),
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    background: state.isFocused ? '#fff' : '#E9EAEE',
                                    height: '70px',
                                    width: '100%',
                                }),
                                menu: (baseStyles, state) => ({
                                    ...baseStyles,
                                    border: ' 1px solid #ABB3D1',
                                    borderRadius: '10px',
                                    margin: '0',
                                    fontSize: '18px !important',
                                }),
                                option: (baseStyles, state) => ({
                                    ...baseStyles,
                                    backgroundColor: state.isFocused ? 'rgba(226, 228, 239, 0.5)' : "white",
                                    height: '80px',
                                    lineHeight: '20px',
                                    fontSize: '18px !important',
                                }),
                                singleValue: (baseSyles) => ({
                                    ...baseSyles,
                                    whiteSpace: 'normal',
                                    height: '57px',
                                    textAlign: 'left',
                                    fontSize: '18px',
                                    lineHeight: '20px',
                                    color: '#201E44',
                                    margin: '0 !important'
                                }),
                            }}
                        />
                    );
                },
                id: 'soilId',
                width: 22,
                getCellClassName: () => "SpreadsheetGrid__cell_focused"
            }, {
                title: 'Гумус\n%',
                value: (row, {focus}) => {
                    return (
                        <div className={row.humus == '0' ? 'no-data-cell' : 'data-cell'}>
                            <Input
                                value={formatCell(row.humus)}
                                focus={focus}
                                selectTextOnFocus={true}
                                onChange={onRegionChange(row.id, 'humus', row.fieldId)}
                            />
                        </div>
                    );
                },
                id: 'humus',
                width: 5,
            }, {
                title: 'pH',
                value: (row, {focus}) => {
                    return (
                        <div className={row.pH == '0' ? 'no-data-cell' : 'data-cell'}>
                            <Input
                                value={formatCell(row.pH)}
                                focus={focus}
                                selectTextOnFocus={true}
                                onChange={onRegionChange(row.id, 'pH', row.fieldId)}
                            />
                        </div>
                    );
                },
                width: 5,
                id: 'pH'
            }, {
                title: 'Плотность\nг/см³',
                value: (row, {focus}) => {
                    return (
                        <div className={row.density == '0' ? 'no-data-cell' : 'data-cell'}>
                            <Input
                                value={formatCell(row.density)}
                                focus={focus}
                                selectTextOnFocus={true}
                                onChange={onRegionChange(row.id, 'density', row.fieldId)}
                            />
                        </div>
                    );
                },
                width: 7,
                id: 'density'
            }, {
                title: 'Глубина\nпах.\nслоя, см',
                value: (row, {focus}) => {
                    return (
                        <div className={row.depthSoil == '0' ? 'no-data-cell' : 'data-cell'}>
                            <Input
                                value={formatCell(row.depthSoil)}
                                focus={focus}
                                selectTextOnFocus={true}
                                onChange={onRegionChange(row.id, 'depthSoil', row.fieldId)}
                            />
                        </div>
                    );
                },
                width: 6,
                id: 'depthSoil'
            }, {
                title: '',
                value: (row, {focus}) => {
                    return (
                        <Col>
                            <Row>
                                <Input
                                    value='кг/га'
                                    focus={focus}
                                />
                            </Row>
                            <hr/>
                            <Row>
                                <Input
                                    value='мг/кг'
                                    focus={focus}
                                />
                            </Row>
                        </Col>
                    );
                },
                width: 5,
                id: 'unit_measurements'
            }, {
                title: 'N',
                value: (row, {focus}) => {
                    return (
                        <Col>
                            <Row className={row.element.n == '0' ? 'no-data-cell' : 'data-cell'}>
                                <Input
                                    value={formatCell(row.element.n, true)}
                                    focus={focus}
                                    selectTextOnFocus={true}
                                    onChange={onRegionChange(row.id, 'element.n', row.fieldId)}
                                />
                            </Row>
                            <hr/>
                            <Row className={row.elementMg.n == '0' ? 'no-data-cell' : 'data-cell'}>
                                <Input
                                    value={formatCell(row.elementMg.n, true)}
                                    focus={focus}
                                    selectTextOnFocus={true}
                                    onChange={onRegion2Change(row.id, 'n', row.fieldId)}
                                />
                            </Row>
                        </Col>
                    );
                },
                id: 'N',
                width: 5
            }, {
                title: 'P₂O₅',
                value: (row, {focus}) => {
                    return (
                        <Col>
                            <Row className={row.element.p2O5 == '0' ? 'no-data-cell' : 'data-cell'}>
                                <Input
                                    value={formatCell(row.element.p2O5, true)}
                                    focus={focus}
                                    selectTextOnFocus={true}
                                    onChange={onRegionChange(row.id, 'element.p2O5', row.fieldId)}
                                />
                            </Row>
                            <hr/>
                            <Row className={row.elementMg.p2O5 == '0' ? 'no-data-cell' : 'data-cell'}>
                                <Input
                                    value={formatCell(row.elementMg.p2O5, true)}
                                    focus={focus}
                                    selectTextOnFocus={true}
                                    onChange={onRegion2Change(row.id, 'p2O5', row.fieldId)}
                                />
                            </Row>
                        </Col>
                    );
                },
                id: 'P2O5',
                width: 5
            }, {
                title: 'K₂O',
                value: (row, {focus}) => {
                    return (
                        <Col>
                            <Row className={row.element.k2O == '0' ? 'no-data-cell' : 'data-cell'}>
                                <Input
                                    value={formatCell(row.element.k2O, true)}
                                    focus={focus}
                                    selectTextOnFocus={true}
                                    onChange={onRegionChange(row.id, 'element.k2O', row.fieldId)}
                                />
                            </Row>
                            <hr/>
                            <Row className={row.elementMg.k2O == '0' ? 'no-data-cell' : 'data-cell'}>
                                <Input
                                    value={formatCell(row.elementMg.k2O, true)}
                                    focus={focus}
                                    selectTextOnFocus={true}
                                    onChange={onRegion2Change(row.id, 'k2O', row.fieldId)}
                                />
                            </Row>
                        </Col>
                    );
                },
                id: 'K2O',
                width: 5
            }, {
                title: 'S',
                value: (row, {focus}) => {
                    return (
                        <Col>
                            <Row className={row.element.s == '0' ? 'no-data-cell' : 'data-cell'}>
                                <Input
                                    value={formatCell(row.element.s, true)}
                                    focus={focus}
                                    selectTextOnFocus={true}
                                    onChange={onRegionChange(row.id, 'element.s', row.fieldId)}
                                />
                            </Row>
                            <hr/>
                            <Row className={row.elementMg.s == '0' ? 'no-data-cell' : 'data-cell'}>
                                <Input
                                    value={formatCell(row.elementMg.s, true)}
                                    focus={focus}
                                    selectTextOnFocus={true}
                                    onChange={onRegion2Change(row.id, 's', row.fieldId)}
                                />
                            </Row>
                        </Col>
                    )
                        ;
                },
                id: 'S',
                width: 5
            }, {
                title: 'CaO',
                value: (row, {focus}) => {
                    return (
                        <Col>
                            <Row className={row.element.caO == '0' ? 'no-data-cell' : 'data-cell'}>
                                <Input
                                    value={formatCell(row.element.caO, true)}
                                    focus={focus}
                                    selectTextOnFocus={true}
                                    onChange={onRegionChange(row.id, 'element.caO', row.fieldId)}
                                />
                            </Row>
                            <hr/>
                            <Row className={row.elementMg.caO == '0' ? 'no-data-cell' : 'data-cell'}>
                                <Input
                                    value={formatCell(row.elementMg.caO, true)}
                                    focus={focus}
                                    selectTextOnFocus={true}
                                    onChange={onRegion2Change(row.id, 'caO', row.fieldId)}
                                />
                            </Row>
                        </Col>
                    )
                },
                id: 'caO',
                width: 5
            }, {
                title: 'Mg',
                value: (row, {focus}) => {
                    return (
                        <Col>
                            <Row className={row.element.mg == '0' ? 'no-data-cell' : 'data-cell'}>
                                <Input
                                    value={formatCell(row.element.mg, true)}
                                    focus={focus}
                                    selectTextOnFocus={true}
                                    onChange={onRegionChange(row.id, 'element.mg', row.fieldId)}
                                />
                            </Row>
                            <hr/>
                            <Row className={row.elementMg.mg == '0' ? 'no-data-cell' : 'data-cell'}>
                                <Input
                                    value={formatCell(row.elementMg.mg, true)}
                                    focus={focus}
                                    selectTextOnFocus={true}
                                    onChange={onRegion2Change(row.id, 'mg', row.fieldId)}
                                />
                            </Row>
                        </Col>
                    )
                },
                id: 'mg',
                width: 5
            }, {
                title: '',
                value: (row) => {
                    return del_button(row.id);
                },
                id: 'button_remove',
                width: 0,
                getCellClassName: () => "SpreadsheetGrid__cell_focused"
            }
        ]

        this.setState({
            rows: rows,
            loading: false,
            columnsRegion: columnsRegion,
            columnsOneRegion: columnsOneRegion,
            check_cropwise: check_cropwise
        });
    }

}
